import React from "react";
import CaseStudyTemplatePage from "components/CaseStudyTemplate/CaseStudyTemplate";

import { useTranslation } from "react-i18next";

import imgBanner from "assets/images/pages/aiAnomalyDetection-banner.jpg";
import imgIdeas2 from "assets/images/pages/aiAnomalyDetection/aiAnomalyDetection-ideas2.jpg";
import imgIdeas1 from "assets/images/pages/aiAnomalyDetection/aiAnomalyDetection-ideas1.jpg";
import imgResult1 from "assets/images/pages/aiAnomalyDetection/aiAnomalyDetection-result1.jpg";
import imgResult2 from "assets/images/pages/aiAnomalyDetection/aiAnomalyDetection-result2.jpg";
import imgResult3 from "assets/images/pages/aiAnomalyDetection/aiAnomalyDetection-result3.jpg";
import imgResult4 from "assets/images/pages/aiAnomalyDetection/aiAnomalyDetection-result4.jpg";
import { PAGES } from "constants/pages";

const CaseStudyAIAnomalyDetectionPage = () => {
  const { t } = useTranslation();
  document.title = t(PAGES.CASE_STUDY_AI_ANOMALY_DETECTION.title);

  const data = {
    banner: {
      header: "caseStudies.aiAnomalyDetection.banner.header",
      text: "caseStudies.aiAnomalyDetection.banner.text",
      badges: t("caseStudies.aiAnomalyDetection.banner.badges", {
        returnObjects: true,
      }),
      image: imgBanner,
      imageHeight: 618,
    },
    stats: t("caseStudies.aiAnomalyDetection.stats", { returnObjects: true }),
    description: {
      header: "caseStudies.aiAnomalyDetection.description.header",
      pargarafs: [
        {
          image: imgIdeas1,
          text: "caseStudies.aiAnomalyDetection.description.paragrafs.paragraf1",
        },
        {
          image: imgIdeas2,
          text: "caseStudies.aiAnomalyDetection.description.paragrafs.paragraf2",
        },
      ],
    },
    businessChallenges: t("caseStudies.aiAnomalyDetection.businessChallenges", {
      returnObjects: true,
    }),
    ourSolutions: t("caseStudies.aiAnomalyDetection.ourSolutions", {
      returnObjects: true,
    }),
    theResults: {
      header: "caseStudies.aiAnomalyDetection.theResults.header",
      content: [
        {
          header: t(
            "caseStudies.aiAnomalyDetection.theResults.results.result1.text"
          ),
          image: imgResult1,
          bgColor: "white",
        },
        {
          header: t(
            "caseStudies.aiAnomalyDetection.theResults.results.result2.text"
          ),
          image: imgResult2,
          bgColor: "softBlue",
        },
        {
          header: t(
            "caseStudies.aiAnomalyDetection.theResults.results.result3.text"
          ),
          image: imgResult3,
          bgColor: "thertiary",
        },
        {
          header: t(
            "caseStudies.aiAnomalyDetection.theResults.results.result4.text"
          ),
          image: imgResult4,
          bgColor: "thertiary",
        },
      ],
    },
    moreStories: {
      title: t("caseStudies.aiAnomalyDetection.moreStories.header"),
      stories: t("caseStudies.aiAnomalyDetection.moreStories.stories", {
        returnObjects: true,
      }),
    },
  };
  return <CaseStudyTemplatePage data={data} />;
};

export default CaseStudyAIAnomalyDetectionPage;
